import interceptorAxios from './InterceptorAxios';
const ServicioReceptor = {
    buscarRfc(receptor){
        return interceptorAxios.post('receptor/buscar_receptor_por_rfc.json',receptor);
    },
    buscarRfcReceptorPorRfc(urlBusqueda , receptor){
        return interceptorAxios.post(urlBusqueda,receptor);
    },
    buscarReceptorLike(receptor){
        return interceptorAxios.post('receptor/buscar_receptor_like_por_rfc.json',receptor);
    },
    comprobarSiExisteReceptor(receptor){
        return interceptorAxios.post('receptor/comprobar_si_existe_receptor.json',receptor);
    },
    guardarReceptor(receptor){
        return interceptorAxios.post('receptor/guardar.json',receptor);
    }
}
export default ServicioReceptor;